import React from "react";

const About = () => {
  return <h1>This is a PWA ABout</h1>;
};

export default About;
